import React from "react"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"
import Sidebar from "./sidebar"

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

const Main = styled.main`
  flex: 1;
  margin-left: 200px;
  overflow: auto;
  height: 100vh;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-top: 60px;
    height: calc(100vh - 60px);
  }
`

interface LayoutProps {
  children: React.ReactNode
  location: { pathname: string }
}

const Layout = ({ children, location }: LayoutProps) => {
  return (
    <LayoutWrapper>
      <Sidebar />
      <Main>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </Main>
    </LayoutWrapper>
  )
}

export default Layout
